"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");
/**
 * Check if we need to enable debug mode
 * It will be true when "localize" is in the url
 *
 * @export {func}
 * @returns {bool} debug mode enabled
 */


function _default() {
  // check for debug mode
  return typeof window !== "undefined" && window.location.search.indexOf('localize') !== -1 && (0, _runtimeConfigHelper.getRuntimeConfig)()._env === 'dev';
}